export default "__VITE_ASSET__C180uHC3__"